const actions = {
  REFRESH_ALL_PLZ: 'REFRESH_ALL_PLZ',
  FETCH_ORG_END_USER_COUNT_DONE: 'FETCH_ORG_END_USER_COUNT_DONE',
  FETCH_ORG_END_USER_COUNT_HISTORY_DONE: 'FETCH_ORG_END_USER_COUNT_HISTORY_DONE',
  FETCH_LATEST_CAMPAIGN_STATS_DONE: 'FETCH_LATEST_CAMPAIGN_STATS_DONE',
  FETCH_OPEN_CONVERSATIONS_DONE: 'FETCH_OPEN_CONVERSATIONS_DONE',
  FETCH_TARGET_CONDITIONS_DONE: 'FETCH_TARGET_CONDITIONS_DONE',
  FETCH_TARGET_CONDITION_DONE: 'FETCH_TARGET_CONDITION_DONE',
  CREATE_TARGET_CONDITION_DONE: 'CREATE_TARGET_CONDITION_DONE',
  PATCH_TARGET_CONDITION_DONE: 'PATCH_TARGET_CONDITION_DONE'
}
export default actions



// WEBPACK FOOTER //
// ./src/scripts/constants/ActionConstants.js